import { render } from "./AppSideNav.vue?vue&type=template&id=3a0ac22c&scoped=true"
import script from "./AppSideNav.vue?vue&type=script&lang=js"
export * from "./AppSideNav.vue?vue&type=script&lang=js"

import "./AppSideNav.vue?vue&type=style&index=0&id=3a0ac22c&scoped=true&lang=css"
import "./AppSideNav.vue?vue&type=style&index=1&id=3a0ac22c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a0ac22c"]])

export default __exports__